import ContactSector from './classes/ContactSector';
import ScrollDetect from './classes/ScrollDetect';

import '../sass/index.scss';

const contactSector = new ContactSector();
const scrollDetect = new ScrollDetect();

document.addEventListener('DOMContentLoaded', () => {
  contactSector.init();
  scrollDetect.init();
});
